module.exports = __webpack_public_path__ + "static/media/video-you-tube-youtube-svgrepo-com.b30cd96f.svg";